import { Link } from "react-router-dom";
import PhotoPlaceholder from "./PhotoPlaceholder";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const resolveImg = (p) => !p ? undefined : (p.startsWith("http") ? p : `${BACKEND}${p}`);

const CATEGORY_LABEL = {
    restaurant: "Restaurant",
    pub: "Pub",
    hotel: "Hôtel",
    "maison-hotes": "Maison d'hôtes",
    villa: "Villa",
    cafe: "Café",
    design: "Design",
    antiquaire: "Antiquaire",
    marche: "Marché",
    "spot-cache": "Spot rare",
    friche: "Friche",
    boutique: "Boutique",
    glacier: "Glacier",
    "coffee-shop": "Coffee shop",
    patrimoine: "Patrimoine",
    jardin: "Nature & Jardin",
    boulangerie: "Boulangerie",
    patisserie: "Pâtisserie",
    fromagerie: "Fromagerie",
    caviste: "Caviste",
    epicerie: "Épicerie fine",
    fleuriste: "Fleuriste",
    librairie: "Librairie",
    musee: "Musée & galerie",
    spa: "Spa",
};

// Pretty city display: blangy-sur-bresle → Blangy-sur-Bresle
const formatCity = (slug) => {
    if (!slug) return "";
    return slug.split("-").map(w => w[0]?.toUpperCase() + w.slice(1)).join("-");
};

export function categoryLabel(cat) { return CATEGORY_LABEL[cat] || cat; }

export default function PlaceCard({ place, index = 0 }) {
    const ratios = ["aspect-[3/4]", "aspect-[4/5]", "aspect-[5/6]"];
    const hasImage = place.image && (place.image.includes('/static/img/v3/') || place.image.includes('/static/img/real/'));
    // Show "Photo officielle" when has_real_photo flag is set on a real-photo path
    // (covers /v3/pl_*, /v3/real_*, and /static/img/real/* — all our real-photo conventions).
    const isOfficialPhoto = place.has_real_photo === true && place.image && (
        place.image.includes('/v3/pl_') ||
        place.image.includes('/v3/real_') ||
        place.image.includes('/static/img/real/')
    );
    return (
        <Link
            to={`/adresses/${place.slug}`}
            data-testid={`place-card-${place.slug}`}
            className="group block"
            style={{ animationDelay: `${index * 60}ms` }}
        >
            <div className={`cp-image-zoom ${ratios[index % 3]} bg-cp-craie overflow-hidden mb-5 relative cp-photo-frame`}>
                {hasImage ? (
                    <img src={resolveImg(place.image)} alt={place.name} loading="lazy" className="w-full h-full object-cover cp-photo-real" />
                ) : (
                    <PhotoPlaceholder name={place.name} category={place.category} />
                )}
            </div>
            <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                    <p className="cp-tiny text-cp-sable-deep mb-2">
                        {categoryLabel(place.category)}
                        {place.city_slug && <span className="mx-2 text-cp-gris">·</span>}
                        {place.city_slug && <span className="text-cp-encre/70">{formatCity(place.city_slug)}</span>}
                        {isOfficialPhoto && <span className="ml-2 inline-flex items-center gap-1 text-cp-foret"><span className="w-1 h-1 rounded-full bg-cp-foret"/> Photo officielle</span>}
                    </p>
                    <h3 className="cp-serif text-3xl md:text-4xl leading-[0.98] text-cp-encre group-hover:italic transition-all">
                        {place.name}
                    </h3>
                    <p className="cp-serif italic text-base text-cp-gris mt-2.5 leading-snug max-w-md">
                        {place.short_description}
                    </p>
                </div>
                {place.price_range && (
                    <span className="cp-mono text-sm text-cp-foret mt-2">{place.price_range}</span>
                )}
            </div>
        </Link>
    );
}
